import { createContext } from 'react';
import type { Locale, TranslationKey } from './translations';

export interface LanguageContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: Record<TranslationKey, any>;
}

export const LanguageContext = createContext<LanguageContextValue | null>(null);
